import { render, staticRenderFns } from "./CourseModal.vue?vue&type=template&id=0d97c817&scoped=true&"
import script from "./CourseModal.vue?vue&type=script&lang=ts&"
export * from "./CourseModal.vue?vue&type=script&lang=ts&"
import style0 from "./CourseModal.vue?vue&type=style&index=0&id=0d97c817&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d97c817",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0d97c817', component.options)
    } else {
      api.reload('0d97c817', component.options)
    }
    module.hot.accept("./CourseModal.vue?vue&type=template&id=0d97c817&scoped=true&", function () {
      api.rerender('0d97c817', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/CourseModal.vue"
export default component.exports